import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { assetWithdraw } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";
import { useTranslation } from 'react-i18next';
import ScrollLockModal from "Component/Common/ScrollLock-Model";

export default function DepositModel(props) {
  
    const dispatch = useDispatch();
    const { user } = useSelector(({ Login }) => Login);
    const { loading } = useSelector((state) => state?.Wallet);
    const copyTextRef = useRef(null);
    const [copySuccess, setCopySuccess] = useState('');
    const toastr = useToastr();
    const { t } = useTranslation();

    const lang = localStorage.getItem("lang")

    useEffect(()=>{
        if(lang =="ar"){
          setCopySuccess(t('نسخ العنوان'))
        }else{
          setCopySuccess(t('Copy Address'))
        }
      },[props.show])
    
    function copyToClipboard(e) {
        copyTextRef.current.select();
        document.execCommand(t('copy'));
        e.target.focus();
        setCopySuccess(t('copied'));
      };
    
        /**
     * Used for render the deposit UI
     */

   
    return (
        <ScrollLockModal
            {...props}

            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="buy_modal Tranferconfirm-modal"
        >
            {loading && <Loader />}

                <div className="modal_inner_main position-relative">
                    <a
                        href="javascript:void(0)"
                        onClick={() => {
                            props.onHide();
                            setCopySuccess('copy_address');
                           
                        }}
                        className="close-btn"
                    >
                        <img src="/images/close_img.png" alt="" className="img-fluid" />
                    </a>


                    <div className="modal_buy-cont">


                        <Row>
                            <Col lg="12" className="my-2">

                                <p className="m-0 text-muted">{t('address')}</p>

                                <textarea
                                    className="form-control"
                                    ref={copyTextRef}
                                    value={props.selectedAsset?.address}
                                    readOnly
                                />
                            </Col>
                        </Row>

                        <Col lg="12" className="my-2">
                        <div className="modal_buy_btn d-flex justify-content-center gap-3">
                                <Button
                                    className="mod_cancelbtn clomod_btn"
                                    onClick={() => {
                                        props.onHide();
                                       
                                    }}
                                >
                                    {t('close')}
                                </Button>
                             
                                    <Button className="mod_confirmbtn copy_btn" onClick={copyToClipboard} type="submit">
                                        {copySuccess}
                                    </Button>
                                
                            </div>
                      </Col>
                    </div>
                </div>
        </ScrollLockModal>
    );
}
